import React, { useState, useEffect } from 'react'
import TableMaterial from '../../../components/tableMaterial/tableMaterial'
import { TableCustomProps } from '../../../components/table/table';
import ButtonUI from '../../../components/button/buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { useGetBlackListCardQuery } from '../../../service/useBlackListCard/useBlackListCard';

export const TableBlackListCard = ({ refresh, setData, onOpen }: { refresh?: number, setData: any,onOpen: React.Dispatch<React.SetStateAction<boolean>> }) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [email, setEmail] = useState<string>("");




  const modalOnclick = (type: string) => {
    setData(type)
    onOpen(true)
  };


  const transformDataToTable = (
    transferences: any[]
  ): TableCustomProps["rows"] => {
    return transferences?.map((transaction) => ({
      name: transaction?.holderName,
      email: transaction?.email,
      number: transaction?.cardNumber,
      date: new Date(transaction?.createdAt).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }),

      delete: (
        <div>
          <ButtonUI
            icon={<FontAwesomeIcon icon={faLockOpen} />}
            onClick={() => modalOnclick(transaction?.cardNumber)}
            color="warning"
          />
        </div>
      ),
    }));
  };

  const { data, isLoading, refetch } = useGetBlackListCardQuery({
    page: page,
    pageSize: rowsPerPage,
    email: email || undefined,
    dateFrom: startDate ? startDate.toISOString() : undefined,
    dateTo: endStarDate ? endStarDate.toISOString() : undefined,
  })



  const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre de cliente" },
      { id: "email", label: "Correo" },
      { id: "number", label: "Numero de tarjeta" },
      { id: "date", label: "Fecha de registro" },
      { id: "delete", label: "Desbloquear" },
    ],
    rows: transformDataToTable(data?.data || []),
  };

  return (
    <div>
      <TableMaterial
        isDate
        setStartDate={setStartDate}
        setEndDate={setEndStartDate}
        id='table-blacklistCard'
        isSearch={true}
        rowsPerPage={rowsPerPage}
        page={1}
        setPage={setPage}
        totalRows={data?.data.pagination?.countData}
        loading={isLoading}
        columns={dataTable?.columns}
        rows={dataTable?.rows}
      />

    </div>
  )
}
